module.exports = __webpack_public_path__ + "img/8c73b7b.png";